import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ProcessInputAppResource from './ProcessInputAppResource';

class ProcessInputCategoryAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'process-input-category';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'processes/inputs/categories';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'description',
            'processInputs',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            processInputs: ProcessInputAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default ProcessInputCategoryAppResource;
